// extracted by mini-css-extract-plugin
export default {"btnAdd":"Buttons_btnAdd__emuxs","btnRemove":"Buttons_btnRemove__RzbXQ"};